module.exports = __webpack_public_path__ + "dc5b8f097bfa5dd31be1f62cd9948e0b.svg";